import { AllSettings } from "@epicgames-ps/lib-pixelstreamingfrontend-ue5.7";

export const DIGITAL_TWIN_TIMEOUT = 20000; // 20 Seconds

export const getDigitalTwinSettings = (pixelStreamingUrl: string): Partial<AllSettings> => ({
    ss: pixelStreamingUrl,
    StartVideoMuted: true,
    // Default to hovering mouse mode as the default camera in DT is orbit
    HoveringMouse: true,
    WaitForStreamer: true,
    AutoPlayVideo: true,
    AutoConnect: false,

    // We do not want to match our viewport resolution exactly as we dont want to be streaming 4k on a 4k monitor
    // We will have our own implementation to update the resolution to be at most 1080p but the correct aspect ratio
    MatchViewportRes: false,

    // Arbitrary, we can monitor this to increase if needed
    MaxReconnectAttempts: 10,

    // AFK Settings
    TimeoutIfIdle: true,
    AFKTimeout: 3600, // How long does the user need to be inactive for (in seconds) before being considered AFK
    AFKCountdown: 10, // How long does the user need to be AFK (in seconds) before being disconnected (has a minimum of 10 seconds)
});
